module.exports = __webpack_public_path__ + "img/arrow-down-white.ab3df119.svg";